import dayjs from "~/config/dayjs";

export const getPackageServiceIds = ({ infoPackage, selectedPackages }) => {
	const ids = new Set();
    if (infoPackage?.body?.bookings) {
        infoPackage.body.bookings.forEach((b) => {
            if (b?.service_id) {
                ids.add(b.service_id);
            }
        });
    }
    if (selectedPackages && Array.isArray(selectedPackages)) {
        selectedPackages.forEach((pkg) => {
            if (pkg?.body?.bookings && Array.isArray(pkg.body.bookings)) {
                pkg.body.bookings.forEach((b) => {
                    if (b?.service_id) {
                        ids.add(b.service_id);
                    }
                });
            }
        });
    }
	return Array.from(ids);
};

export const buildPackageCheckoutPayload = (packageItem, matchedService) => {
	if (!packageItem) return null;
	const durationMin = matchedService?.professional?.duration || packageItem?.service?.duration || 0;
	const startIso = matchedService?.time?.start ? dayjs(matchedService.time?.start).utc().format() : undefined;
	const endIso = matchedService?.time?.start
		? dayjs(matchedService.time?.start).utc().add(durationMin, "minute").format()
		: undefined;
	const bookings = Array.from({ length: packageItem.quantity || 0 }).map(() => ({
		business_id: packageItem.business?.id,
		professional_id: packageItem.professional?.id || matchedService?.professional?.id,
		service_id: packageItem.service?.id,
		pricing_type_id: packageItem.pricingType?.id,
		acesso: "web",
		answer: "",
		price: (packageItem.price || 0) / (packageItem.quantity || 1),
	}));
    
	return {
		body: { bookings, is_cancellation_policy: false, is_offer_refused: false, package_id: packageItem.id },
		info: {
			serviceName: packageItem.service?.name || packageItem.service?.serviceName,
			duration: packageItem.service?.duration || packageItem.service?.serviceDuration,
			packageName: packageItem.name,
			pricingType: packageItem.pricingType,
			quantity: packageItem.quantity,
			packagePrice: packageItem.price,
			validity: packageItem.bookingExpirationDays,
		},
		serviceDateTime: { start_time: startIso, end_time: endIso },
		accepted_offer: true,
		serviceLinkedPackage: matchedService,
	};
};
